/**
 * @generated SignedSource<<d926770f9e5e3d332e801dcf3b8a2a9b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type DashboardBlockLeaderboardLookbackWindow = "last_30_days" | "last_365_days" | "last_7_days" | "last_90_days" | "last_month" | "last_week" | "last_year" | "this_month" | "this_week" | "this_year" | "%future added value";
export type DashboardBlockLeaderboardView = "card" | "list" | "%future added value";
export type DashboardBlockPosition = "main" | "side" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type LeaderboardDashboardBlockFragment$data = {
  readonly blockDescription: string;
  readonly blockView: DashboardBlockLeaderboardView;
  readonly id: string;
  readonly lookbackWindow: DashboardBlockLeaderboardLookbackWindow;
  readonly memberCount: number;
  readonly organizationId: string;
  readonly position: DashboardBlockPosition;
  readonly product: {
    readonly id: string;
    readonly slug: string;
  } | null;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"DashboardBlockAdminDropdownFragment" | "DashboardBlockItemTemplateFragment">;
  readonly " $fragmentType": "LeaderboardDashboardBlockFragment";
};
export type LeaderboardDashboardBlockFragment$key = {
  readonly " $data"?: LeaderboardDashboardBlockFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"LeaderboardDashboardBlockFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LeaderboardDashboardBlockFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "organizationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "memberCount",
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": "blockDescription",
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "position",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lookbackWindow",
      "storageKey": null
    },
    {
      "alias": "blockView",
      "args": null,
      "kind": "ScalarField",
      "name": "view",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DashboardBlockAdminDropdownFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DashboardBlockItemTemplateFragment"
    }
  ],
  "type": "LeaderboardDashboardBlock",
  "abstractKey": null
};
})();

(node as any).hash = "58af0c370cac4762d72b4248dc927bea";

export default node;
